import Vue from 'vue';
import Vuetify from 'vuetify';
import { Context } from '@nuxt/types';
import icons from '~/settings/icons';
import theme from '~/settings/theme';
import asterisk from '~/components/common/asterisk.vue';
import phone from '~/components/common/phone.vue';
import dropdown from '~/components/common/dropdown.vue';
import radioOff from '~/components/common/radioOff.vue';
import radioOn from '~/components/common/radioOn.vue';
import checkboxOn from '~/components/common/checkboxOn.vue';
import checkboxOff from '~/components/common/checkboxOff.vue';
const values = icons(Vue);

Vue.use(Vuetify);

export default (context: Context, inject: (name: string, value: unknown) => void) => {
    context.app.vuetify = new Vuetify({
        theme,
        icons: {
            iconfont: 'fa',
            values: {
                ...values,
                asterisk: {
                    // name of our custom icon
                    component: asterisk, // our custom component
                },
                phone : {
                    component : phone
                },
                dropdown : {
                    component : dropdown
                },
                radioOff : {
                    component : radioOff
                },
                radioOn : {
                    component : radioOn
                },
                checkboxOn : {
                    component : checkboxOn
                },
                checkboxOff : {
                    component : checkboxOff
                }
            },
        },
    });
    context.$vuetify = context.app.vuetify;
};
